export default __webpack_public_path__ + "static/media/wechat-white.47da237d.svg";